
import {Routes} from '@angular/router';
import {TaxSitesComponent} from './components/tax-sites/tax-sites.component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
export const TaxSitesRoutes: Routes = [
  {
    path      : 'itrce/tax-sites',
    //component: TaxSitesComponent,
    component: PlatformLinkCreatorComponent,
  }
];
